export default __webpack_public_path__ + "static/media/53.4b0467b1.png";